import { aboutValues } from "@/mocks/home";

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-24">
      <div className="w-full px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-14 items-center">
          <div className="reveal order-2 lg:order-1">
            <div className="w-full h-[280px] md:h-[420px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20editorial%20still%20life%20of%20a%20night%20newsroom%20desk%20with%20magnifying%20glass%20resting%20on%20printed%20documents%2C%20a%20small%20desk%20lamp%20casting%20amber%20light%2C%20deep%20red%20folder%20and%20notebook%2C%20muted%20cream%20and%20crimson%20color%20palette%2C%20soft%20shadows%2C%20minimal%20artistic%20composition%2C%20no%20people%2C%20no%20readable%20text&width=1200&height=1000&seq=juguangtai-about-01&orientation=squarish"
                alt="聚光台编辑组核验线索的工作场景"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="reveal inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-[0.15em] text-primary-600">
              <span className="w-6 h-px bg-primary-500"></span>
              关于我们
            </span>
            <h2 className="reveal mt-3 md:mt-4 font-heading text-2xl md:text-4xl font-bold leading-snug text-foreground-950">
              一个把「核实」放在第一位，被举报的爆料台
            </h2>
            <div className="reveal mt-4 md:mt-5 flex flex-col gap-4 text-sm md:text-base leading-relaxed text-foreground-600">
              <p>
                聚光台是一个专注网红爆料的线索征集与核验平台。我们不生产八卦，只做一件事：把大家散落在私信、群聊、订单里的真实材料，整理成经得起追问的线索。
              </p>
              <p>
                网站定位是「公众可参与的核实台」。任何网友都能匿名投稿，也能查看每条线索的处理结论；当事人则可以提交反证，申请更正或撤下。核验标准、处理结果全程公开。
              </p>
              <p>
                我们相信，爆料的价值不取决于它有多刺激，而取决于它有多扎实。因此宁可慢一点、少一点，也不发布一条没有证据链支撑的内容。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {aboutValues.map((item, index) => (
            <div
              key={item.title}
              className="reveal bg-background-100 border border-background-200 rounded-lg p-5 md:p-6"
              style={{ animationDelay: `${index * 0.06}s` }}
            >
              <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}